/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import PropTypes from 'prop-types';

const propTypes = {
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hideLabel: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  arrayOne: PropTypes.bool,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hideLabel: false,
  hasError: false,
  arrayOne: false,
  onChange: () => {},
  loading: false,
  customFilter: {},
  value: '',
};

const limit = 10;

const BranchSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    hideLabel = false,
    hasError = false,
    arrayOne = false,
    loading: isLoadingProps = false,
    customFilter = {},
    value = '',
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const getBranches = useApi(MsAccount.getBranches);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {};
      if (customFilter && Object.keys(customFilter).length) {
        filter = customFilter;
      }
      if (val) {
        filter.name = { $regex: val, $options: 'i' };
      }
      if (!val && filter.name) {
        delete filter.name;
      }
      const response = await getBranches.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      label="Branch"
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore ? 'Loading...' : 'Select Branch'
      }
      trackBy="id"
      labelKey="name"
      isRequired={isRequired}
      multiple={multiple}
      hideLabel={hideLabel}
      editable={editable && !loading.initial && !isLoadingProps}
      hasError={hasError}
      arrayOne={arrayOne}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        if (!isLoadingProps) {
          setSkip(0);
          onSearch();
        }
      }}
    />
  );
};

BranchSearch.propTypes = propTypes;
BranchSearch.defaultProps = defaultProps;

export default BranchSearch;
